@if (isTemplate) {
  <span class="tooltip-icon tooltip-wrapper"
        (mouseenter)="show = true"
        (mouseleave)="show = false">
    <i class="fa fa-info-circle"></i>
    @if (show) {
      <div class="tooltip-popup" role="tooltip">
        <ng-container [ngTemplateOutlet]="asTemplate"></ng-container>
      </div>
    }
  </span>
} @else {
  <span class="tooltip-icon" [matTooltip]="asString" matTooltipPosition="right"><i class="fa fa-info-circle"></i></span>
}
